<template>
    <o-card :title="$t('sandoz.assortment_analysis_detail')">
        <o-input :errorField="'title'" :label="$t('sandoz.title')" v-model="title"/>
        <o-value-select :items="analysisTypes" :label="$t('sandoz.analysis_types')" v-model="settings.analysisType"/>

        <template v-if="settings.analysisType === 'molecule'">
            <o-form-group :label="$t('sandoz.molecules')">
                <b-btn @click="settings.molecules.push({'molecule': ''})" size="sm">
                    <fa icon="plus"/>
                </b-btn>
                <table>
                    <tr v-for="(molecule, moleculeIndex) in settings.molecules">
                        <td>
                            <vue-typeahead-bootstrap
                                style="min-width: 320px;"
                                v-model="molecule.molecule"
                                :data="molecules"
                            />
                        </td>
                        <td>
                            <b-btn @click="settings.molecules.splice(moleculeIndex, 1)">
                                <fa icon="times"/>
                            </b-btn>
                        </td>
                    </tr>
                </table>
            </o-form-group>
        </template>
        <template v-if="settings.analysisType === 'gtin_list'">
            <o-form-group :label="$t('sandoz.gtin_list')">
                <b-btn @click="settings.gtins.push({'gtin': ''})" size="sm">
                    <fa icon="plus"/>
                </b-btn>
                <table>
                    <tr v-for="(gtin, gtinIndex) in settings.gtins">
                        <td>
                            <o-input-control v-model="gtin.gtin"></o-input-control>
                        </td>
                        <td>
                            <b-btn @click="settings.gtins.splice(gtinIndex, 1)">
                                <fa icon="times"/>
                            </b-btn>
                        </td>
                    </tr>
                </table>
            </o-form-group>
        </template>

        <o-button @click="save" :loading="saving">{{$t('sandoz.request_analysis')}}</o-button>

    </o-card>
</template>

<script>
import axios from 'axios'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'

export default {
    data: () => ({
        analysisTypes: [],
        settings: {
            analysisType: 'molecule',
            molecules: [],
            gtins: []
        },
        title: '',
        saving: false,
        molecules: []
    }),
    mounted() {
        axios.get('/api/sandoz/molecules?sortBy=molecule&per_page=99999').then((response) => {
            this.molecules = response.data.data.map(i => i.molecule)
        }).catch((error) => {
            console.error(error)
        })
    },
    methods: {
        save() {
            let $self = this

            if (!this.title) {
              $self.$notify({
                  title: $self.$i18n.t('core.save_error'),
                  text: $self.$i18n.t('sandoz.title_required'),
                  type: 'error'
              })
              return
            }

            this.saving = true
            var url = '/api/sandoz/assortment_analysis/request'
            var data = {
                title: this.title,
                analysis_settings: this.settings
            }
            axios.post(url, data).then((response) => {
                $self.saving = false
                this.$router.back()
            }).catch((error) => {
                $self.saving = false
                $self.$notify({
                    title: $self.$i18n.t('core.save_error'),
                    text: $self.$i18n.t('core.save_error_text', {url: url}),
                    type: 'error'
                })
            })
        }
    },
    created() {
        this.analysisTypes = [
            {value: 'molecule', text: this.$t('sandoz.molecule')},
            {value: 'gtin_list', text: this.$i18n.t('sandoz.gtin_list')}
        ]
    },
    components: {
        VueTypeaheadBootstrap
    }
}
</script>
